import axios from "axios";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { Button, Nav, Tab } from "react-bootstrap";
import { useParams } from "react-router-dom";
import swal from "sweetalert";
import { serverInfo } from "../../../../../../App";
import { FanGroupContext } from "../../../../../../CustomHelper/Helper";
import ContentLoader from "../../../../../../Screen/ContentLoader";
import PackageModal from "../../../../../Modal/CategoryModal/PackageModal";

import Chatting from "../../../../../Pages/GroupChat/Chatting";
import Navigation from "../../../../Header/Navigation";
import noImage from "../../../../../../Assets/Images/settings/no-image.png";
import CreatePostModal from "./CreatePostModal";
import FanAnalytics from "./FanAnalytics";
import FanMedia from "./FanMedia";
import FanMember from "./FanMember";
import FanPost from "./FanPost";
import "./FanStar.css";
import Default from "./MessageGroup/Default";

const FanStar = () => {
  const { imageCdnUrl } = useContext(serverInfo);
  const [messagenger, setMessenger] = useState(false);
  const [fanJoinDetails, setFanJoinDetails] = useState("");
  const [fanDetails, setFanDetails] = useState("");
  const [shareCountContext, setShareCountContext] = useState({});
  const [modalShowPost, setModalShowPost] = React.useState(false);
  const [modalShowPackage, setModalShowPackage] = React.useState(false);
  const [active, setActive] = useState("home");
  const [showChat, setShowChat] = useState(true);

  const [fanPost, setFanPost] = useState([]);
  const [title, setTitle] = React.useState("Join Now");
  const [starId] = React.useState("");
  const [participant, setParticipant] = useState();

  const [buffer, setBuffer] = useState(true);

  const { slug } = useParams();

  // const fanPostModelFun = (data) => {
  //   setModalShowPost(data);
  // };
  const packageModelFun = (data) => {
    setModalShowPackage(data);
    handleReload();
  };

  // const [fanDetails, setFanDetails] = useState("");
  // const [fanJoinDetails, setFanJoinDetails] = useState("");
  // const { fanDetails, setFanDetails } = useContext(FanGroupContext);
  // const { fanJoinDetails, setFanJoinDetails } = useContext(FanGroupContext);

  const [my_star, setMyStar] = useState("");
  const [another_star, setMyAnotherStar] = useState("");
  const [fanGroupId, setFanDetailsId] = useState("");
  const [userPoints, setFanUserPoints] = useState("");
  const [color, setColor] = useState();
  const [chatUser, setChatUser] = useState();
  const [fanPostType, setFanPostType] = useState("");
  const [userInfo, setUserInfo] = useState("");

  const handlePost = (type) => {
    setFanPostType(type);
    setModalShowPost(true);
  };

  function handleClick() {
    setMessenger(!messagenger);
  }
  useEffect(() => {
    axios.get(`/api/user/fan/group/${slug}`).then((res) => {
      setBuffer(false);
      if (res.status === 200) {
        setFanDetails(res.data.fanDetails);
        setMyStar(res.data.my_star);
        setMyAnotherStar(res.data.another_star);
        setFanDetailsId(res.data.fanId);
        setFanUserPoints(res.data.userPoints);
        setParticipant(res.data?.participant);
        setChatUser(
          res.data.my_user_join.length + res.data.another_user_join.length
        );
      }
    });

    axios.get(`api/user_info`).then((res) => {
      if (res.data.status === 200) {
        setUserInfo(res.data.users);
      }
    });
  }, [slug]);

  const selectStar = (starName, starId) => {
    const formData = new FormData();

    formData.append("fan_group_id", fanGroupId);
    formData.append("star_name", starName);
    formData.append("star_id", starId);
    //add member to group
    axios.post(`/api/user/fan/group/store`, formData).then((res) => {
      if (res.data.status === 200) {
        handleReload();
        if (fanDetails.join_approval_status == 1) {
          swal("Welcome", res.data.message, "success");
        } else {
          swal("Pending", "Your request under review", "success");
        }
      }
    });
  };
  // + fanDetails.my_user_join .another_user_join.length

  useEffect(() => {
    axios.get(`/api/user/fan/group/join/${fanGroupId}`).then((res) => {
      if (res.status === 200) {
        setFanJoinDetails(res.data.fanJoinDetails);
        setTitle(res.data.fanJoinDetails.star_name);

        if (res.data.fanJoinDetails?.star_id === fanDetails?.my_star) {
          setColor(1);
        } else {
          setColor(2);
        }
      }
    });
  }, [fanGroupId]);

  const handleReload = () => {
    axios.get(`/api/user/fan/group/join/${fanGroupId}`).then((res) => {
      if (res.status === 200) {
        setFanJoinDetails(res.data.fanJoinDetails);
        setTitle(res.data.fanJoinDetails.star_name);

        if (res.data.fanJoinDetails?.star_id === fanDetails?.my_star) {
          setColor(1);
        } else {
          setColor(2);
        }
      }
    });

    axios.get(`/api/user/fan/group/${slug}`).then((res) => {
      if (res.status === 200) {
        setFanDetails(res.data.fanDetails);
        setMyStar(res.data.my_star);
        setMyAnotherStar(res.data.another_star);
        setFanDetailsId(res.data.fanId);
        setFanUserPoints(res.data.userPoints);
        setChatUser(
          res.data.my_user_join.length + res.data.another_user_join.length
        );
      }
    });
  };

  return (
    <>
      <Navigation totalNotification={0} />
      <div className="container">
        <div className="mt-3">
          {buffer ? (
            <ContentLoader />
          ) : (
            <img
              src={imageCdnUrl + fanDetails.banner}
              alt=""
              className="img-fluid StartCover mb-2"
            />
          )}
          <h4 className="text-light fw-bold TitleFan">
            {fanDetails.group_name}
          </h4>
          <p className="subTitleFan">
            Created at {moment(fanDetails.start_date).format("LL")} | Continue
            till {moment(fanDetails.end_date).format("LL")}
          </p>
        </div>

        {/* Fan Group Messenger */}
        <i
          onClick={handleClick}
          className="fab fa-facebook-messenger text-warning fa-4x fan-messenger"
        ></i>
        {/* Fan Group Messenger */}

        <div className="FanNave">
          <div className="row">
            <div className="col-md-12 col-lg-8 mb-3 PositionTabX">
              <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                <Nav
                  variant="pills"
                  className="d-flex flex-wrap MobileFabNave justify-content-around"
                >
                  <Nav.Item>
                    {active === "home" ? (
                      <Nav.Link
                        className="fw-bold bgNavFan my-2"
                        eventKey="first"
                      >
                        <i className="fa fa-house-user me-1"></i>Home
                      </Nav.Link>
                    ) : (
                      <Nav.Link
                        className="fw-bold fanNavText my-2"
                        eventKey="first"
                        onClick={() => setActive("home")}
                      >
                        <i className="fa fa-house-user me-1"></i>Home
                      </Nav.Link>
                    )}

                    {/* <Nav.Link className="fw-bold  my-2" eventKey="first">
                      <i className="fa fa-house-user me-1"></i>Home
                    </Nav.Link> */}
                  </Nav.Item>
                  <Nav.Item>
                    {active === "media" ? (
                      <Nav.Link
                        className="fw-bold my-2 bgNavFan"
                        eventKey="second"
                      >
                        <i className="fa fa-house-user me-1"></i> Media
                      </Nav.Link>
                    ) : (
                      <Nav.Link
                        className="fw-bold my-2 fanNavText"
                        eventKey="second"
                        onClick={() => setActive("media")}
                      >
                        <i className="fa fa-house-user me-1"></i> Media
                      </Nav.Link>
                    )}
                  </Nav.Item>
                  <Nav.Item>
                    {active === "analytics" ? (
                      <Nav.Link
                        className="fw-bold bgNavFan my-2"
                        eventKey="fifth"
                      >
                        <i className="fa fa-house-user me-1"></i> Analytics
                      </Nav.Link>
                    ) : (
                      <Nav.Link
                        className="fw-bold fanNavText my-2"
                        eventKey="fifth"
                        onClick={() => setActive("analytics")}
                      >
                        <i className="fa fa-house-user me-1"></i> Analytics
                      </Nav.Link>
                    )}
                    {/* <Nav.Link
                      className="fw-bold bgNavFan my-2"
                      eventKey="fifth"
                    >
                      <i className="fa fa-house-user me-1"></i> Analytics
                    </Nav.Link> */}
                  </Nav.Item>
                  <Nav.Item>
                    {active === "member" ? (
                      <Nav.Link
                        className="fw-bold bgNavFan my-2"
                        eventKey="third"
                      >
                        <i className="fa fa-house-user me-1"></i>Member
                      </Nav.Link>
                    ) : (
                      <Nav.Link
                        className="fw-bold fanNavText my-2"
                        eventKey="third"
                        onClick={() => setActive("member")}
                      >
                        <i className="fa fa-house-user me-1"></i>Member
                      </Nav.Link>
                    )}
                  </Nav.Item>

                  <i
                    // onClick={() => setShowChat(!showChat)}
                    onClick={handleClick}
                    className="fa-brands fa-facebook-messenger PositionTabXMessage mt-2"
                  ></i>

                  {Number(fanDetails.club_points) === 0 ? (
                    <Nav.Item>
                        <div className="dropdown de1 my-2">
                          <Button type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"
                            className={ color === 1 ? `SelectFanDefaultTwo` : color === 2 ? `SelectFanDefaultThree` : `SelectFanDefault` } >
                            {title}
                          </Button>

                          <ul className={color ? "" : "dropdown-menu "} aria-labelledby="dropdownMenuButton1" >
                            {color ? null : (
                              <>
                                <li>
                                  <Button className="SelectFanDefaultTwo"
                                    onClick={() => selectStar(
                                        my_star.first_name +  " " + my_star?.last_name, fanDetails.my_star
                                      )
                                    }
                                  >
                                    {my_star.first_name} {my_star?.last_name}
                                  </Button>
                                </li>
                                <li>
                                  <Button
                                    className="SelectFanDefaultThree"
                                    onClick={() =>
                                      selectStar(another_star?.first_name + " " + another_star?.last_name, fanDetails?.another_star
                                      )
                                    }
                                  >
                                    {another_star?.first_name} {another_star?.last_name}
                                  </Button>
                                </li>
                              </>
                            )}
                          </ul>
                        </div>
                    </Nav.Item>
                  ) : (
                    <Nav.Item>
                      {Number(userPoints.club_points) >=
                        Number(fanDetails.club_points) ||
                      (Number(userPoints.club_points) === null &&
                        Number(fanDetails.club_points) === 0) ? (
                        <div className="dropdown de1 my-2">
                          <Button
                            type="button"
                            id="dropdownMenuButton1"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            className={
                              color === 1
                                ? `SelectFanDefaultTwo`
                                : color === 2
                                ? `SelectFanDefaultThree`
                                : `SelectFanDefault`
                            }
                          >
                            {title}
                          </Button>

                          <ul
                            className={color ? "" : "dropdown-menu "}
                            aria-labelledby="dropdownMenuButton1"
                          >
                            {color ? null : (
                              <>
                                <li>
                                  <Button
                                    className="SelectFanDefaultTwo"
                                    onClick={() =>
                                      selectStar(
                                        my_star.first_name +
                                          " " +
                                          my_star?.last_name,
                                        fanDetails.my_star
                                      )
                                    }
                                  >
                                    {my_star.first_name} {my_star?.last_name}
                                  </Button>
                                </li>
                                <li>
                                  <Button
                                    className="SelectFanDefaultThree"
                                    onClick={() =>
                                      selectStar(
                                        another_star?.first_name +
                                          " " +
                                          another_star?.last_name,
                                        fanDetails?.another_star
                                      )
                                    }
                                  >
                                    {another_star?.first_name}{" "}
                                    {another_star?.last_name}
                                  </Button>
                                </li>
                              </>
                            )}
                          </ul>
                        </div>
                      ) : Number(userPoints.club_points) <
                          Number(fanDetails.club_points) ||
                        (Number(userPoints.club_points) === null &&
                          Number(fanDetails.club_points) > 0) ||
                        !Number(userPoints.club_points) ? (
                        <Button
                          type="button"
                          onClick={() => setModalShowPackage(true)}
                          className={`SelectFanDefault`}
                        >
                          Join Now
                        </Button>
                      ) : (
                        ""
                      )}
                    </Nav.Item>
                  )}
                </Nav>

                {Number(fanJoinDetails?.approveStatus) === 1 ? (
                  <>
                    <div className="row">
                      <div className="col-12">
                        <div className="card-bg1 d-flex p-3  justify-content-between align-items-center rounded-3">
                          <img
                            src={
                              userInfo.image
                                ?
                                  imageCdnUrl+userInfo.image
                                : noImage
                            }
                            alt=""
                            className="createPostFan me-2"
                          />
                          <button
                            className="btn creat-Post-Fan"
                            onClick={() => handlePost("allPost")}
                          >
                            &nbsp; Start a post
                          </button>

                          <button
                            className="btnVideo card-bg1 mx-2 d-flex align-items-center"
                            onClick={() => handlePost("photoPost")}
                          >
                            <i className=" fan-iconP fa-solid fa-image "></i>
                          </button>

                          <button
                            className="btnVideo card-bg1 d-flex align-items-center"
                            onClick={() => handlePost("videoPost")}
                          >
                            <i className=" fan-iconV fa-solid fa-video"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <CreatePostModal
                      show={modalShowPost}
                      onHide={() => setModalShowPost(false)}
                      fanPostType={fanPostType}
                    />
                  </>
                ) : (
                  ""
                )}

                <Tab.Content>
                  <Tab.Pane eventKey="first" className="">
                    {Number(fanJoinDetails?.approveStatus) === 1 ? (
                      <FanPost
                        fanPost={fanPost}
                        setFanPost={setFanPost}
                        fanDetails={fanDetails}
                      />
                    ) : (
                      ""
                    )}
                  </Tab.Pane>

                  <Tab.Pane eventKey="second">
                    {Number(fanJoinDetails?.approveStatus) === 1 ? (
                      <FanMedia />
                    ) : (
                      ""
                    )}
                  </Tab.Pane>

                  <Tab.Pane eventKey="fifth">
                    {Number(fanJoinDetails?.approveStatus) === 1 ? (
                      <FanAnalytics />
                    ) : (
                      ""
                    )}
                  </Tab.Pane>

                  <Tab.Pane eventKey="third">
                    {Number(fanJoinDetails?.approveStatus) === 1 ? (
                      <FanMember />
                    ) : (
                      ""
                    )}
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>

            {/* Chat Box */}

            {/* Messaging start */}
            <>
              {messagenger ? (
                <>
                  {fanJoinDetails ? (
                    Number(fanJoinDetails.approveStatus) === 0 ? (
                      <div className="col-sm-12 col-md-6 col-lg-4 MessengerHead mb-2 ">
                        <div className="MessengerHead3">
                          <div className=" MessengerBody py-3 ps-2 text-light">
                            <h6 className="fw-bold mx-2">Group inbox</h6>

                            <div className="top-right-messenger">
                              {/* <span>
            <img src={PicMa} alt="" className="PicMessenger" />
          </span>
          <span>
            <img src={PicMa} alt="" className="PicMessenger" />
          </span>
          <span>
            <img src={PicMa} alt="" className="PicMessenger" />
          </span> */}
                              {/* <span className="messengerUser"> & 20 more</span> */}
                              <i
                                class="fa-solid fa-circle-xmark text-danger"
                                onClick={handleClick}
                              ></i>
                            </div>
                          </div>
                          <Default />{" "}
                        </div>
                      </div>
                    ) : (
                      <div className="col-sm-12 col-md-6 col-lg-4 MessengerHead mb-2 ">
                        <div className="MessengerHead3">
                          <div className=" MessengerBody py-3 ps-2 text-light">
                            <h6 className="fw-bold mx-2">Group inbox</h6>

                            <div className="top-right-messenger">
                              {/* <span className="messengerUser"> {chatUser} users</span> */}
                              <i
                                class="fa-solid fa-circle-xmark text-danger"
                                onClick={handleClick}
                              ></i>
                            </div>
                          </div>
                          <Chatting
                            participant={participant}
                            groupInfo={fanDetails}
                            color={color}
                            chatUser={chatUser}
                          ></Chatting>
                        </div>
                      </div>
                    )
                  ) : (
                    <div className="col-sm-12 col-md-6 col-lg-4 MessengerHead mb-2 ">
                      <div className="MessengerHead3">
                        <div className=" MessengerBody py-3 ps-2 text-light">
                          <h6 className="fw-bold mx-2">Group inbox</h6>

                          <div className="top-right-messenger">
                            {/* <span>
            <img src={PicMa} alt="" className="PicMessenger" />
          </span>
          <span>
            <img src={PicMa} alt="" className="PicMessenger" />
          </span>
          <span>
            <img src={PicMa} alt="" className="PicMessenger" />
          </span> */}
                            {/* <span className="messengerUser"> & 20 more</span> */}
                            <i
                              class="fa-solid fa-circle-xmark text-danger"
                              onClick={handleClick}
                            ></i>
                          </div>
                        </div>
                        <Default />{" "}
                      </div>
                    </div>
                  )}
                </>
              ) : null}
            </>
            {/* Messaging end */}
          </div>
        </div>
      </div>

      <PackageModal
        fanGrpupInfo={fanDetails}
        walateInfo={userPoints}
        setFanUserPoints={setFanUserPoints}
        show={modalShowPackage}
        onHide={() => setModalShowPackage(false)}
        packageShowModel={packageModelFun}
        className="ModalXC"
        setModalShowPackage={setModalShowPackage}
      />
    </>
  );
};

export default FanStar;
